import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const FullWidthLink = styled(Link)`
    width: 100%;
`;
